var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "envelop-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cafaee",
    d: "M18.133 25.156h-4.267c-4.178 0-6.311 0-7.733-1.422s-1.422-3.556-1.422-7.733 0-6.311 1.422-7.733 3.556-1.422 7.733-1.422h4.267c4.178 0 6.311 0 7.733 1.422 0.8 0.8 1.156 1.778 1.333 3.467 0 0.356-0.267 0.711-0.622 0.711s-0.711-0.267-0.711-0.622c-0.089-1.333-0.444-2.044-0.978-2.578-1.067-1.067-3.022-1.067-6.844-1.067h-4.267c-3.822 0-5.778 0-6.844 1.067s-1.067 3.022-1.067 6.844c0 3.822 0 5.778 1.067 6.844s3.022 1.067 6.844 1.067h4.267c3.822 0 5.778 0 6.844-1.067s1.067-3.022 1.067-6.844c0-0.356 0.267-0.711 0.711-0.711s0.711 0.267 0.711 0.711c0 4.178 0 6.311-1.422 7.733-1.511 1.333-3.644 1.333-7.822 1.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cafaee",
    d: "M16 16.8c-0.8 0-1.511-0.267-2.489-0.978-0.267-0.178-0.356-0.622-0.178-0.889s0.622-0.356 0.889-0.178c0.711 0.533 1.244 0.711 1.778 0.711 0.889 0 1.867-0.8 3.644-2.311l2.311-1.956c0.267-0.267 0.711-0.178 0.978 0.089s0.178 0.711-0.089 0.978l-2.311 1.956c-2.044 1.689-3.111 2.578-4.533 2.578zM11.556 14.044c-0.178 0-0.267-0.089-0.444-0.178l-1.956-1.6c-0.267-0.267-0.267-0.711-0.089-0.978 0.267-0.267 0.622-0.356 0.978-0.089l1.956 1.6c0.267 0.267 0.356 0.622 0.089 0.978-0.178 0.178-0.356 0.267-0.533 0.267z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopIcon);
export default __webpack_public_path__ + "static/media/envelop-icon.4f5ccc1f78b276cb7a23766d2dba48a4.svg";
export { ForwardRef as ReactComponent };